import 'react-tabs/style/react-tabs.css';
import React, { FC } from 'react';
import Sheet from '@mui/joy/Sheet';
import AddAnUser from './AddAnUser';
import CssBaseline from '@mui/joy/CssBaseline';
import GlobalFiltersView from './GlobalFilters/GlobalFiltersView';
import GlobalFiltersSelect from './GlobalFilters/GlobalFiltersSelect';
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import { styleSheetProfileCard } from './ProfileUserCard';
import { darkModeBackgroud } from '../../../utils/constants';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../store/useLanguageStore';

export interface ProfileAdditionalInfoProps {
    email?: string;
    mode: "ADD" | "EDIT" | "VIEW" | "PROFILE";
}

export const ProfileAdditionalInfo: FC<ProfileAdditionalInfoProps> = ({ email, mode }) => {

    const view = mode === 'VIEW';
    const add = mode === 'ADD';

    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();

    return (
        <div className='profile-info-card'>
            <CssBaseline />
            <Sheet
                sx={{
                    ...styleSheetProfileCard,
                    width: '100%',
                    background: darkMode ? darkModeBackgroud : 'white',
                }}
            >
                <Tabs className="mt-2">
                    <TabList className="coreTabs d-flex flex-lg-row flex-column"
                        style={{ background: "transparent" }}>
                        <Tab
                            key={"Profile-Tab-1"}
                            className={`coreTabButton ${darkMode && 'coreTabButton-dark-mode'}`}
                        >
                            Account Settings
                        </Tab>
                        {
                            !add
                            && <Tab
                                key={"Profile-Tab-2"}
                                className={`coreTabButton ${darkMode && 'coreTabButton-dark-mode'}`}
                            >
                                {language['GlobalFilters']}
                            </Tab>
                        }
                    </TabList>
                    <TabPanel>
                        <AddAnUser mode={mode} />
                    </TabPanel>
                    {
                        !add
                        && <TabPanel>
                            {
                                view
                                    ? <GlobalFiltersView email={email} />
                                    : <GlobalFiltersSelect email={email} />
                            }
                        </TabPanel>
                    }
                </Tabs>
            </Sheet>
        </div>
    );
}
export default ProfileAdditionalInfo